import './styles.scss'

import React from 'react'
import PropTypes from 'prop-types'

import starGray from './_assets/star-gray.png'
import starWhite from './_assets/star-white.png'
import starGreen from './_assets/star-green.png'

const Rating = ({ percentage, white }) => (
  <div className='standard-rating'>
    <div className='bg'>
      <img src={white ? starWhite : starGray} width='125' height='19' alt='rating star' />
    </div>
    <div className='active' style={{ width: `${Math.round(percentage)}%`, overflow: 'hidden' }}>
      <img src={starGreen} width='125' height='19' alt='rating green star' />
    </div>
  </div>
)

Rating.propTypes = {
  percentage: PropTypes.number.isRequired,
  white: PropTypes.bool
}

export default Rating
